module.exports = __webpack_public_path__ + "static/img/swiper1.dc724b8b.webp";